import React from 'react'
import Tilt from 'react-parallax-tilt';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
};

const PortfolioCard = ({ projectData }) => {
    return (
        <>
            <motion.div 
                className="card-container grid grid-two-column"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.1 }}
            >
                {projectData.map((curElem) => {
                    const { id, image, projectLink, projectName, description, techStack } = curElem;
                    return (
                        <motion.div variants={itemVariants} key={id} style={{height: '100%'}}>
                            <Tilt 
                                tiltMaxAngleX={10} 
                                tiltMaxAngleY={10} 
                                perspective={1000} 
                                scale={1.02} 
                                transitionSpeed={2500}
                                glareEnable={true}
                                glareMaxOpacity={0.15}
                                glareColor="#f43f5e"
                                glarePosition="all"
                                style={{height: "100%", display: "flex", flexDirection: "column"}}
                            >
                                <div className="card portfolio-card p-0" style={{display: 'flex', flexDirection: 'column', flex: '1', background: 'rgba(30, 41, 59, 0.6)', border: '1px solid rgba(255,255,255,0.05)'}}>
                                    <div style={{position: 'relative', overflow: 'hidden'}}>
                                        <img className="card-img-top" src={image} alt={projectName} style={{width: '100%', objectFit: 'cover', borderBottom: '1px solid rgba(255,255,255,0.05)'}} />
                                        <div className="project-link">
                                            <a href={projectLink} target="_blank" rel='noreferrer'><i className="fa-solid fa-link"></i></a>
                                        </div>
                                    </div>
                                    <div className="card-body" style={{padding: '2rem', flex: '1', display: 'flex', flexDirection: 'column'}}>
                                        <h5 className="card-title m-0 pb-2" style={{fontSize: '2rem', fontWeight: 'bold', color: 'var(--main-text-color)'}}>{projectName}</h5>
                                        {description && <p style={{fontSize: '1.4rem', color: 'var(--text-color)', marginBottom: '1.5rem', lineHeight: '1.6'}}>{description}</p>}
                                        {techStack && (
                                            <div style={{display: 'flex', flexWrap: 'wrap', gap: '0.8rem', marginTop: 'auto'}}>
                                                {techStack.map((tech, idx) => (
                                                    <span key={idx} style={{backgroundColor: 'rgba(248, 69, 108, 0.1)', color: 'var(--primary-color)', border: '1px solid var(--primary-color)', padding: '0.4rem 0.8rem', borderRadius: '0.5rem', fontSize: '1.1rem', fontWeight: 'bold'}}>{tech}</span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Tilt>
                        </motion.div>
                    )
                })}
            </motion.div>
        </>
    )
}

export default PortfolioCard